import {DEFAULT_HOST, routeTo} from '@/utils/router'

export const getSpecimenGuideContent = () => ({
  metaTitle: 'specimen-guide.meta-title',
  metaDescription: 'specimen-guide.meta-desc',
  ogImage: {
    url: `${DEFAULT_HOST}/images/og-images/specimen-guide-en.png`,
    width: 1200,
    height: 627,
    alt: 'Specimen guide - OG image',
  },
  hero: {
    title: 'specimen-guide.hero-title',
    subtitle: 'specimen-guide.hero-subtitle',
  },
  selection: {
    classSearchTitle: 'specimen-guide.class-search-title',
    industrySearchTitle: 'specimen-guide.industry-search-title',
    buttonText: 'specimen-guide.go-to-guide-button',
  },
  mostPopularSectorsTitle: 'specimen-guide.most-popular-sectors-title',
  otherPopularSectorsTitle: 'specimen-guide.other-popular-sectors-title',
  guide: {
    metaTitle: 'specimen-guide.guide-meta-title',
    metaDescription: 'specimen-guide.guide-meta-desc',
    hero: {
      title: 'specimen-guide.guide-hero-title',
      classSubtitle: 'specimen-guide.guide-for-class-hero-subtitle',
      sectorSubtitle: 'specimen-guide.guide-for-sector-hero-subtitle',
    },
    examplesTitle: 'specimen-guide.specimen-examples-title',
    sourceTitle: 'specimen-guide.source-title',
    imageAtFullSizeTitle: 'specimen-guide.image-at-full-size-title',
    sidebarCard: {
      title: 'specimen-guide.submit-specimen-card-title',
      description: 'specimen-guide.submit-specimen-card-desc',
      imageSrc: '/images/icons/submission.svg',
      imageAlt: 'Trademark specimen submission',
    },
    faqs: {
      buttonLinkHref: routeTo.trademarkQA.category('trademark-specimen'),
      buttonLinkText: 'specimen-guide.all-specimen-questions-title',
    },
  },
  ctaBanner: {
    title: 'specimen-guide.submit-specimen-banner-title',
    description: 'specimen-guide.submit-specimen-banner-desc',
    imageSrc: '/images/test-tube.svg',
    imageAlt: 'Person carrying a test tube',
    registration: {
      linkText: 'specimen-guide.register-trademark-title',
      linkHref: routeTo.verification.form(),
      trackedEventName: 'Register a trademark is clicked',
    },
    sou: {
      linkText: 'specimen-guide.submit-sou-title',
      linkHref: routeTo.statementOfUse(),
      trackedEventName: 'Submit Statement of use is clicked',
    },
    dou: {
      linkText: 'specimen-guide.submit-dou-title',
      linkHref: routeTo.declarationOfUse(),
      trackedEventName: 'Submit Declaration of use is clicked',
    },
  },
})
